import { Badge, Card, Icon } from '@/components/primitives';
import { PageHeader } from '@/components/layout/PageHeader';

interface Props {
  title: string;
  phase: string;
  breadcrumb?: string[];
  description?: string;
}

export function PlaceholderPage({ title, phase, breadcrumb, description }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader
        title={title}
        subtitle={`Phase ${phase} chưa triển khai — bộ khung đã sẵn sàng`}
        breadcrumb={breadcrumb}
        actions={<Badge kind="DRAFT">{phase}</Badge>}
      />
      <div style={{ flex: 1, padding: 20 }}>
        <Card>
          <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: 'var(--bx-surface-2)',
                color: 'var(--bx-text-muted)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Icon name="clock" size={16} />
            </div>
            <div>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: 'var(--bx-text-heading)',
                  marginBottom: 4,
                }}
              >
                Đang chờ Phase {phase}
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: 'var(--bx-text-muted)',
                  lineHeight: 1.55,
                  maxWidth: 640,
                }}
              >
                {description ??
                  'Foundation đã xong (M0 + M1: scaffold, layout, auth mock, domain types, services, seed data). Phase này sẽ thêm các màn hình cụ thể theo plan ở openspec/changes/wfp-mvp/.'}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
